import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import AiReportList from './AiReportList';
import AiReportEdit from './AiReportEdit';

export default {
    list: AiReportList,
    edit: AiReportEdit,
    icon: ReportProblemIcon,
    recordRepresentation: (record: any) => `Report ${record?.report_id || record?.id || ''}`,
};
